<template>
  <div class="main-player">
    <music
      v-if="list"
      theme="#5b246d"
      :music="song"
      :list="list"
      listFolded
      :volume="1"
      controls
    />
  </div>
</template>

<script>
import Aplayer from "vue-aplayer";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      list: undefined,
      song: undefined,
    };
  },
  computed: {
    // getting store main music list (vuex)
    ...mapGetters(["musicPlaylist"]),
  },
  watch: {
    // before added music list first song selected aplayer
    musicPlaylist(newValue, oldValue) {
      if (newValue.length) {
        this.list = newValue;
        this.song = newValue[0];
      }
    },
  },
  components: { music: Aplayer },
  created() {
    // music list request
    this.$store.dispatch("music_playlist");
  },
};
</script>

<style lang="scss" scoped>
.aplayer {
  padding: 5px;
  margin: 0;
  border-radius: 0;
}
</style>
